import {useEffect, useMemo} from 'react'
import {Column} from 'react-table'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellNonMultiple,
} from '../../../../../../components/UI'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {useKhipu} from '../../../../../../hooks/useKhipu'
import {useLimpieza} from '../../../../../../hooks/useLimpieza'
import {TabLimpiezaModel} from '../../../../../../models'
import {useCampaments} from '../../../../hooks/central/useCampaments'
import {useClients} from '../../../../hooks/central/useClients'
import {useCompanies} from '../../../../hooks/central/useCompanies'
import {useParameters} from '../../../../hooks/central/useParameters'
import {useSites} from '../../../../hooks/central/useSites'
import {CREATION_CELLPHONES_SERVICES} from '../../../../services'

const TableCreationCellphones = () => {
  const {
    data,
    setData,
    setPagination,
    loading,
    setLoading,
    pagination,
    clearSelected,
    selectedOn,
    clearTable,
    updateTable,
    setClearTable,
    setUpdateTable,
  } = useKTable()
  const {changeCurrentTabItem, currentTabItem, isAllowed} = useLimpieza()

  const {searchValues, clearSearchValues} = useKhipu()
  const {getCompanies, companies} = useCompanies()
  const {getClients, clients} = useClients()
  const {getSites, sites} = useSites()
  // const {getCampaments, campaments} = useCampaments()
  const {getStatusCellphones, getSuppliersCellphones, statusCellphones, suppliersCellphones} =
    useParameters()

  const getCellpones = async () => {
    try {
      setLoading(true)
      const {data: response} = await CREATION_CELLPHONES_SERVICES.getCellphoneList({
        pageNumber: pagination.currentPage,
        size: pagination.perPage,
        ...searchValues,
      })
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (currentTabItem.loadingTable || updateTable) {
      clearSelected()
      getCellpones()
      setUpdateTable(false)
      setClearTable(false)
      changeCurrentTabItem({...currentTabItem, loadingTable: false})
    } else {
      getCellpones()
    }
  }, [pagination.currentPage, currentTabItem.loadingTable, updateTable])

  useEffect(() => {
    getCompanies({isCombo: true}, 1)
    getClients({isCombo: true}, 1)
    getSites({isCombo: true}, 1)
    // getCampaments({isCombo: true}, 1)
    getStatusCellphones(
      {pageNumber: 1, size: 200, tableName: 'ESTADOCELULAR'},
      {},
      {idKey: 'codigo', labelKey: 'nombreCorto'},
    )
    getSuppliersCellphones(
      {pageNumber: 1, size: 200, tableName: 'PROVCELULARES'},
      {},
      {idKey: 'codigo', labelKey: 'nombreCorto'},
    )
    return () => {
      clearSearchValues()
    }
  }, [])

  const handleViewPanel = (data: any) => {
    const obj: TabLimpiezaModel = {
      ...currentTabItem,
      showPanel: true,
      idToEdit: data.Id,
      idToDelete: '',
      content: {
        ...currentTabItem.content,
        detailPanel: 'form-creation-of-cellphones',
      },
    }
    changeCurrentTabItem(obj)
    clearSelected()
  }

  const handleGetId = (id: any) => {
    let idChange = id === currentTabItem.idToDelete ? '' : id
    const obj: TabLimpiezaModel = {
      ...currentTabItem,
      showPanel: false,
      idToDelete: idChange,
      idToEdit: '',
    }
    changeCurrentTabItem(obj)
  }

  const columns: Column<any>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} />,
        id: 'selection',
        Cell: ({...props}) => (
          <KTableSelectionCellNonMultiple
            id={props.data[props.row.index].Id}
            clickHandler={handleGetId}
          />
        ),
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Compañía'
            name={'CompaniaId'}
            selecteable
            data={companies}
          />
        ),
        accessor: 'Compania',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Cliente'
            name={'ClienteId'}
            selecteable
            data={clients}
          />
        ),
        accessor: 'Cliente',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Site' name={'SiteId'} selecteable data={sites} />
        ),
        accessor: 'Site',
      },
      // {
      //   Header: (props) => (
      //     <KTableHeader
      //       tableProps={props}
      //       title='Campamento'
      //       name={'CampamentoId'}
      //       selecteable
      //       data={campaments}
      //     />
      //   ),
      //   accessor: 'Campamento',
      // },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Numero de Celular'
            name={'nroCelular'}
            searcheable
          />
        ),
        accessor: 'NroCelular',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Proveedor de Servicio'
            name='ProveedorServicio'
            selecteable
            data={suppliersCellphones}
          />
        ),
        accessor: 'ProveedorServicio',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Modelo' name={'modelo'} searcheable />
        ),
        accessor: 'Modelo',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Marca' name={'marca'} searcheable />
        ),
        accessor: 'Marca',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Nro de Serie' name={'nroSerie'} searcheable />
        ),
        accessor: 'NroSerie',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Estado'
            name='Estado'
            selecteable
            data={statusCellphones}
          />
        ),
        accessor: 'Estado',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
        id: 'actions',
        Cell: ({...props}) => (
          <div
            className='d-flex justify-content-center flex-shrink-0'
            onClick={() => handleViewPanel(props.row.original)}
          >
            <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
              <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
            </a>
          </div>
        ),
      },
    ],
    [companies, clients, sites, /*campaments,*/ suppliersCellphones, statusCellphones, selectedOn],
  )

  return (
    <KTCard shadow className='m-5'>
      <KTable data={data} columns={columns} />
      {loading ? <KTableLoading title='Cargando...' /> : null}
    </KTCard>
  )
}

export const CreationCellphonesTable = () => {
  return (
    <KTableProvider>
      <TableCreationCellphones />
    </KTableProvider>
  )
}
